import { lazyLoad } from 'app/utils/loadable';

export const RepairPage = lazyLoad(
  () => import('./repair-page'),
  (module) => module.RepairPage
);
